'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'GET_STAGES_START':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ loading: true }));

    case 'GET_STAGES':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ all: action.payload.map(function (stage) {
          return stage.id;
        }) }));

    case 'CREATE_STAGE':
      return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).push(action.payload.id));

    case 'DELETE_STAGE':
      return state.setIn([action.feis_id, 'all'], (state.getIn([action.feis_id, 'all']) || (0, _immutable.List)()).filter(function (id) {
        return id !== action.stage_id;
      }));

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/stages/index.js
// module id = 701
// module chunks = 0